<ng-container *ngIf="features$ | async">
	<ng-container *ngIf="formGroup">
		<form [formGroup]="formGroup" class="cm-form mt-32" (ngSubmit)="handleSubmit()">
			<ng-container *ngIf="!(isBasic$ | async)">
				<cm-autocomplete
					[options$]="intents$"
					formControlName="intent"
					class="cm-form__field-group--full-width">
					<cm-localize
						[name]="locs.SPSelectionFormFieldLabelIntent"
						[cpName]="locs.CPSelectionFormFieldLabelIntent" />
					<div
						autocomplete-errors
						*ngIf="intent.invalid && (intent.dirty || intent.touched)">
						<div *ngIf="intent.errors.required">
							<cm-localize
								[name]="locs.SPSelectionFormFieldErrorIntentRequired"
								[cpName]="locs.CPSelectionFormFieldErrorIntentRequired" />
						</div>
						<div *ngIf="intent.errors.noMatch">
							<cm-localize
								[name]="locs.SPSelectionFormFieldErrorIntentInvalid"
								[cpName]="locs.CPSelectionFormFieldErrorIntentInvalid" />
						</div>
					</div>
				</cm-autocomplete>
			</ng-container>

			<ng-container *ngIf="!(isBasic$ | async) && !(hideCredentials$ | async)">
				<cm-autocomplete
					[options$]="credentials$"
					formControlName="credential"
					class="cm-form__field-group--full-width">
					<cm-localize
						[name]="locs.SPSelectionFormFieldLabelCredential"
						[cpName]="locs.CPSelectionFormFieldLabelCredential" />
					<div
						autocomplete-errors
						*ngIf="credential.invalid && (credential.dirty || credential.touched)">
						<div *ngIf="credential.errors.noCerts">
							<cm-localize
								[name]="locs.SPSelectionFormFieldErrorNoCredentials"
								[cpName]="locs.CPSelectionFormFieldErrorNoCredentials" />
						</div>
						<div *ngIf="credential.errors.required">
							<cm-localize
								[name]="locs.SPSelectionFormFieldErrorCredentialRequired"
								[cpName]="locs.CPSelectionFormFieldErrorCredentialRequired" />
						</div>
						<div *ngIf="credential.errors.noMatch">
							<cm-localize
								[name]="locs.SPSelectionFormFieldErrorCredentialInvalid"
								[cpName]="locs.CPSelectionFormFieldErrorCredentialInvalid" />
						</div>
					</div>
				</cm-autocomplete>
			</ng-container>

			<cm-autocomplete
				[options$]="itemGroups$"
				formControlName="group"
				class="cm-form__field-group--full-width">
				<cm-localize
					[name]="locs.SPSelectionFormFieldLabelItemGroup"
					[cpName]="locs.CPSelectionFormFieldLabelItemGroup" />
				<div autocomplete-errors *ngIf="group.invalid && (group.dirty || group.touched)">
					<div *ngIf="group.errors.required">
						<cm-localize
							[name]="locs.SPSelectionFormFieldErrorItemGroupRequired"
							[cpName]="locs.CPSelectionFormFieldErrorItemGroupRequired" />
					</div>
					<div *ngIf="group.errors.noMatch">
						<cm-localize
							[name]="locs.SPSelectionFormFieldErrorItemGroupInvalid"
							[cpName]="locs.CPSelectionFormFieldErrorItemGroupInvalid" />
					</div>
				</div>
			</cm-autocomplete>

			<cm-autocomplete
				[options$]="itemNames$"
				formControlName="name"
				class="cm-form__field-group--full-width">
				<cm-localize
					[name]="locs.SPSelectionFormFieldLabelItemName"
					[cpName]="locs.CPSelectionFormFieldLabelItemName" />
				<div autocomplete-errors *ngIf="name.invalid && (name.dirty || name.touched)">
					<div *ngIf="name.errors.required">
						<cm-localize
							[name]="locs.SPSelectionFormFieldErrorItemNameRequired"
							[cpName]="locs.CPSelectionFormFieldErrorItemNameRequired" />
					</div>
					<div *ngIf="name.errors.noMatch">
						<cm-localize
							[name]="locs.SPSelectionFormFieldErrorItemNameInvalid"
							[cpName]="locs.CPSelectionFormFieldErrorItemNameInvalid" />
					</div>
				</div>
			</cm-autocomplete>

			<cm-autocomplete
				[options$]="overrideGroups$"
				formControlName="overrideGroup"
				class="cm-form__field-group--full-width">
				<cm-localize
					[name]="locs.SPSelectionFormFieldLabelOverrideGroup"
					[cpName]="locs.CPSelectionFormFieldLabelOverrideGroup" />
				<div autocomplete-errors *ngIf="overrideGroup.invalid && (overrideGroup.dirty || overrideGroup.touched)">
					<div *ngIf="overrideGroup.errors.required">
						<cm-localize
							[name]="locs.SPSelectionFormFieldErrorOverrideGroupRequired"
							[cpName]="locs.CPSelectionFormFieldErrorOverrideGroupRequired" />
					</div>
					<div *ngIf="overrideGroup.errors.noMatch">
						<cm-localize
							[name]="locs.SPSelectionFormFieldErrorOverrideGroupInvalid"
							[cpName]="locs.CPSelectionFormFieldErrorOverrideGroupInvalid" />
					</div>
				</div>
			</cm-autocomplete>

			<cm-autocomplete
				[options$]="overrideNames$"
				formControlName="overrideName"
				class="cm-form__field-group--full-width">
				<cm-localize
					[name]="locs.SPSelectionFormFieldLabelOverrideName"
					[cpName]="locs.CPSelectionFormFieldLabelOverrideName" />
				<div autocomplete-errors *ngIf="overrideName.invalid && (overrideName.dirty || overrideName.touched)">
					<div *ngIf="overrideName.errors.required">
						<cm-localize
							[name]="locs.SPSelectionFormFieldErrorOverrideNameRequired"
							[cpName]="locs.CPSelectionFormFieldErrorOverrideNameRequired" />
					</div>
					<div *ngIf="overrideName.errors.noMatch">
						<cm-localize
							[name]="locs.SPSelectionFormFieldErrorOverrideNameInvalid"
							[cpName]="locs.CPSelectionFormFieldErrorOverrideNameInvalid" />
					</div>
				</div>
			</cm-autocomplete>
			<div class="cm-form__actions">
				<button mat-raised-button color="primary" type="submit">
					<cm-localize
						[name]="locs.SPSelectionFormButtonStepOneNext"
						[cpName]="locs.CPSelectionFormButtonStepOneNext" />
				</button>
			</div>
		</form>
	</ng-container>
</ng-container>
